import React, { Component } from 'react';

class ShowSnack extends Component {
  render() {
    return <div>Header</div>;
  }
}

export default ShowSnack;
